<div class="card-list">
  <ng-container *ngFor="let appNotice of appNotices">
    <a
      *ngIf="appNoticeLinks[appNotice.name] as cardLink; else noLink"
      [crossAppLink]="'/settings/a/' + agency.id + cardLink"
      [class]="cardAlertClass(appNotice)">
      <ng-content *ngTemplateOutlet="coreAppNoticeMessage"></ng-content>
    </a>
    <ng-template #noLink>
      <div
        [class]="cardAlertClass(appNotice)"
        style="cursor: default">
        <ng-content *ngTemplateOutlet="coreAppNoticeMessage"></ng-content>
      </div>
    </ng-template>
    <ng-template #coreAppNoticeMessage>
      <core-app-notice-message
        [appNotice]="appNotice"
        [agency]="agency"
        [company]="company"
        [user]="user"
        [withPadding]="true">
      </core-app-notice-message>
    </ng-template>
  </ng-container>
</div>
